import { useQuery } from '@tanstack/react-query'
import { apiClient } from '@/api/client'
import type { components } from '@/api/types'

/** Generált típusok a backend OpenAPI-ból (DEC-BILLING-007). */
export type UsageReport = components['schemas']['UsageReport']
export type UsageReportBucket = components['schemas']['UsageReportBucket']
export type Granularity = 'day' | 'week' | 'month'

export interface UsageReportParams {
  from: string
  to: string
  granularity: Granularity
}

export const USAGE_REPORT_QUERY_KEY = ['admin', 'billing', 'reports'] as const

/**
 * `GET /admin/billing/reports` — aggregált viselkedés-riport a megadott
 * intervallumra (DEC-BILLING-007). A kvóta-metrikák akkor is gyűlnek a
 * backend usage_counters-ében, ha a korlátozás (flag) ki van kapcsolva.
 */
export function useUsageReport(params: UsageReportParams) {
  return useQuery({
    queryKey: [...USAGE_REPORT_QUERY_KEY, params],
    queryFn: async (): Promise<UsageReport> => {
      const { data, error } = await apiClient.GET('/admin/billing/reports', {
        params: { query: params },
      })
      if (error) throw error
      if (!data?.data) throw new Error('Empty report response')
      return data.data
    },
  })
}

/**
 * Ugyanaz az endpoint `format=csv`-vel — nyers CSV szöveget ad vissza
 * (parseAs: 'text'), amit a komponens Blob-ként letölt.
 */
export async function fetchUsageReportCsv(params: UsageReportParams): Promise<string> {
  const { data, error } = await apiClient.GET('/admin/billing/reports', {
    params: { query: { ...params, format: 'csv' } },
    parseAs: 'text',
  })
  if (error) throw error
  return (data as unknown as string | undefined) ?? ''
}
